import { baseUrl } from "../utils/baseUrl";
import jwtInterceptor from "./autorizacao/jwt-interceptor";

class ServicossSolicitacaoExterna {
    create(pedido) {
        return jwtInterceptor.post(`${baseUrl}/solicitacaoExternaProduto`, pedido)
    }
   
    listarSolicitacaoExternaPorColaborador(id){
        return jwtInterceptor.get(`${baseUrl}/solicitacaoExternaProduto/lista/${id}`)
    }

    cancelarPedido(id_solicitacao, motivo){
        let aux = {
            observacao: `${motivo}`,
            status: "cancelado"
        }

        return jwtInterceptor.put(`${baseUrl}/solicitacaoExternaProduto/${id_solicitacao}`, aux)
    }

    editar(id, solicitacao){
        return jwtInterceptor.put(`${baseUrl}/solicitacaoExternaProduto/${id}`, solicitacao)
    }
    listarSolicitacoesPendentes(){
        return jwtInterceptor.get(`${baseUrl}/solicitacaoExternaProduto/pendentes`)
    }

    deletar(id){
        return jwtInterceptor.delete(`${baseUrl}/solicitacaoExternaProduto/${id}`)
    }

    cancelarSolicitacao(id_solicitacao, solicitacao){
        return jwtInterceptor.put(`${baseUrl}/solicitacaoExternaProduto/${id_solicitacao}`, solicitacao)
    }

    listarTodasSolicitacoes(){
        return jwtInterceptor.get(`${baseUrl}/solicitacaoExternaProduto`)
    }
}

export default new ServicossSolicitacaoExterna();